import React from 'react';
import { connect } from 'react-redux';
import SaveVocabularyDialog from './SaveVocabularyDialog';

const VocabularyDialogs = ({ allowSave, theme }) => (
  <>
    {allowSave && (<SaveVocabularyDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { vocabularies: { update } } } },
  vocabularies: { activeVocabulary },
}) => ({
  allowSave: activeVocabulary.open && update,
});

export default connect(mapStateToProps)(VocabularyDialogs);
